import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import MuiAlert, { AlertProps, Color } from "@material-ui/lab/Alert";
import React from "react";

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

type Props = {
  color: string;
  bgColor: string;
};

const useStyles = makeStyles<Theme, Props>((theme) =>
  createStyles({
    root: {
      width: "100%",
      marginTop: 10,
      "& > * + *": {
        marginTop: theme.spacing(2),
      },
      "& .MuiAlert-outlinedInfo": {
        color: ({ color }) => color,
        border: ({ color }) => `1px solid ${color}`,
        backgroundColor: ({ bgColor }) => bgColor,
      },
      "& .MuiPaper-elevation6": {
        boxShadow: "none",
      },
      "& .MuiAlert-outlinedInfo .MuiAlert-icon": {
        color: ({ color }) => color,
      },
    },
  })
);

interface ISnackBar {
  severity?: Color;
  content: React.ReactNode | React.ReactElement;
  color?: string;
  bgColor?: string;
}

export default function SnackBar({ severity = "info", content, color = "#399ebf", bgColor = "#fff" }: ISnackBar) {
  const classes = useStyles({ color, bgColor });
  return (
    <div className={classes.root}>
      <Alert severity={severity} variant="outlined">
        {content}
      </Alert>
    </div>
  );
}
